export interface FilterConfigResponse {
  data: Data;
}

export interface DataFromApi {
  items: FilterConfigItem[];
}

export interface Data extends DataFromApi {
  filterConfigRecords: Record<string, FilterConfigItem | undefined>;
  filterTypes: FilterConfigType[];
  filterTexts: Record<string, Record<string, string>>;
}

export enum FilterConfigPage {
  Category = 'category',
  Search = 'search',
  OnSale = 'on_sale',
  BestSellers = 'best_sellers',
  NewArrivals = 'new_arrivals',
  Vendors = 'vendors',
  Default = 'default',
}

export enum FilterConfigType {
  Price = 'price',
  Color = 'color',
  Pattern = 'pattern',
  Category = 'category',
}

export type FilterProps = {
  [K in FilterConfigType]?: string | string[];
};

export interface FilterConfigItem {
  type:
    | FilterConfigType.Price
    | FilterConfigType.Color
    | FilterConfigType.Pattern
    | FilterConfigType.Category;
  terms: Term[];
}

export type Term = Color | Price | Pattern | Category;

export interface Color {
  text: string;
  hex: string;
}

export interface Price {
  min_price: string;
  max_price: string;
}

export interface Pattern {
  text: string;
  value: string;
  image_url: string;
}

export interface Category {
  id: number;
  name: string;
  count: number;
}
